import React from "react"
import { Navigate } from "react-router-dom"
import { useDrop } from "../contexts/DropContext"

export default function DropRoute({ children }) {
    const { currentDrop } = useDrop();
    return currentDrop ? children : <Navigate to="/projects" replace />;
}
  